export default "__VITE_ASSET__0231eea5__"